import { useMemo } from "react"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { ComparisonFacilityHeaderCell } from "./comparison-facility-header-cell"
import { ComparisonFacilityBreakdownRow } from "./comparison-facility-breakdown-row"

export function ComparisonFacilityBreakdown({ variants }) {
    const facilityNames = useMemo(getFacilityNames, [variants])

    return (
        <TableContainer component={Box} sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}>
            <Table data-cy="comparison-facility-table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography variant="subtitle2">Facility</Typography>
                        </TableCell>
                        <Repeat list={variants} item={<ComparisonFacilityHeaderCell />} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Bound variants={variants}>
                        <Repeat list={facilityNames} item={<ComparisonFacilityBreakdownRow />} pass="facilityName" />
                    </Bound>
                </TableBody>
            </Table>
        </TableContainer>
    )

    function getFacilityNames() {
        const nameSet = new Set()
        for (const v of variants) {
            const facilities = v?.costResult?.facilityBreakdown ?? []
            for (const f of facilities) {
                if (f.facilityName) nameSet.add(f.facilityName)
            }
        }
        return [...nameSet].sort()
    }
}
